export const getUrlParams = (strUrl?: string) => {
  const url = strUrl || window.location.hash;
  const theRequest: any = {};
  const index = url.indexOf('?');
  if (index !== -1) {
    const str = url.substring(index + 1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
    }
  }
  return theRequest;
};
